import '../fix-sdk-path';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import GlobalStyle from '../style/global';
import AdhocDisplayApp from '../components/adhoc/AdhocDisplayApp';
import AdhocFamilyPackPage from '../components/adhoc/AdhocFamilyPackPage';
import AdhocSingleScanCheckoutPage from '../components/adhoc/AdhocSingleScanCheckoutPage';

const Wrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div
    style={{
      width: '100%',
      height: '100dvh',
      minHeight: '100dvh',
      overflowY: 'auto',
      overflowX: 'hidden',
      WebkitOverflowScrolling: 'touch',
    }}
  >
    {children}
  </div>
);

ReactDOM.render(
  <BrowserRouter basename={process.env.ROUTER_BASENAME || ''}>
    <Wrapper>
      <GlobalStyle />
      <Routes>
        <Route path="/display/family-pack" element={<AdhocFamilyPackPage />} />
        <Route path="/display/checkout" element={<AdhocSingleScanCheckoutPage />} />
        <Route path="/display" element={<AdhocDisplayApp />} />
        <Route path="/" element={<Navigate to="/display?adhoc_id=default" replace />} />
        <Route path="*" element={<Navigate to="/display?adhoc_id=default" replace />} />
      </Routes>
    </Wrapper>
  </BrowserRouter>,
  document.getElementById('root'),
);
